import { render, staticRenderFns } from "./pricingTier.vue?vue&type=template&id=0bdcf4e8"
import script from "./pricingTier.vue?vue&type=script&lang=js"
export * from "./pricingTier.vue?vue&type=script&lang=js"
import style0 from "./pricingTier.vue?vue&type=style&index=0&id=0bdcf4e8&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gobo-app/gobo-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0bdcf4e8')) {
      api.createRecord('0bdcf4e8', component.options)
    } else {
      api.reload('0bdcf4e8', component.options)
    }
    module.hot.accept("./pricingTier.vue?vue&type=template&id=0bdcf4e8", function () {
      api.rerender('0bdcf4e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pricingTier.vue"
export default component.exports